module.exports = __webpack_public_path__ + "img/icon9.8c739590.png";